/**
 * Button Group Edit Mode functions
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

import {
	ISchemaComponentModel,
	ISchemaConstObjectModel,
	MEDIA_RESOLUTIONS_default,
	MEDIA_RESOLUTIONS_string,
	SCHEMA_VALUE_TYPE,
	TGenericComponentInstance
} from "@adapptio/lib-blueprint";

import {
	IAllowedResizeDimensions,
	IComponentListElementPlaceholder,
	TResizeAfterRenderHandler,
	IResizeOffset,
	TComponentListElement,
	getStringEnumCssValue,
	SPACING
} from "@adapptio/lib-components";

import { isValidObject } from "@adapptio/lib-shared";

import { TButtonGroupItemInheritedProps } from "./props";

/**
 * Resolves child inline style
 */
export function resolveChildInlineStyle(
	element: TComponentListElement<TButtonGroupItemInheritedProps>,
	index: number,
	media: MEDIA_RESOLUTIONS_string
): React.CSSProperties | undefined {
	if (element.type !== "placeholder") {
		return;
	}

	const result: React.CSSProperties = {};

	const inheritedProps = element.inheritedProps as Record<string, unknown>;

	return result;
}
